"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _TagsIndex = _interopRequireDefault(require("@insided/deprecated-preact-components/algolia/TagsIndex"));

var _service = require("./service");

var _utils = require("./utils");

var _PublicTagOverviewPresenter = _interopRequireDefault(require("@insided/deprecated-control/public-tag-overview/PublicTagOverviewPresenter"));

var _debounce = require("@insided/shared/utils/debounce");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PublicTagOverview = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PublicTagOverview, _Component);

  var _super = _createSuper(PublicTagOverview);

  function PublicTagOverview(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PublicTagOverview);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "index", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      tags: [],
      messageType: null,
      message: '',
      modalErrorMessage: '',
      isLoading: false,
      isPaginationSet: false,
      pagination: {
        page: _utils.DEFAULT_PAGE,
        pageSize: _utils.DEFAULT_PAGE_SIZE,
        total: 0
      },
      searchText: '',
      retries: 0,
      tagsToMerge: [],
      selectAllTagsOnPage: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchTags", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var page,
          pageSize,
          _yield$_this$index$se,
          hits,
          nbHits,
          _args = arguments;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              page = _args.length > 0 && _args[0] !== undefined ? _args[0] : _utils.DEFAULT_PAGE;
              pageSize = _args.length > 1 && _args[1] !== undefined ? _args[1] : _utils.DEFAULT_PAGE_SIZE;

              _this.setState({
                isLoading: true
              });

              _context.prev = 3;
              _context.next = 6;
              return _this.index.searchByName(_this.state.searchText, page, pageSize);

            case 6:
              _yield$_this$index$se = _context.sent;
              hits = _yield$_this$index$se.hits;
              nbHits = _yield$_this$index$se.nbHits;

              if (!(hits.length === 0 && page > 1)) {
                _context.next = 13;
                break;
              }

              _context.next = 12;
              return _this.fetchTags(Math.ceil(nbHits / pageSize), pageSize);

            case 12:
              return _context.abrupt("return");

            case 13:
              _this.setState(function (prevState) {
                return {
                  tags: hits,
                  isLoading: false,
                  pagination: _objectSpread(_objectSpread({}, prevState.pagination), {}, {
                    total: nbHits,
                    pageSize: pageSize,
                    page: page
                  }),
                  messageType: undefined,
                  message: undefined,
                  retries: 0
                };
              });

              _context.next = 25;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](3);

              if (!(_this.state.retries < 3)) {
                _context.next = 24;
                break;
              }

              _this.setState(function (prevState) {
                return {
                  retries: prevState.retries + 1
                };
              });

              _context.next = 22;
              return _this.fetchTags(page, pageSize);

            case 22:
              _context.next = 25;
              break;

            case 24:
              _this.setState({
                isLoading: false,
                messageType: 'error',
                message: 'Failed to load tags after three retries. Try again later.'
              });

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 16]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "debouncedFetchTags", (0, _debounce.debounceAsync)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var page,
          pageSize,
          _args2 = arguments;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              page = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : _utils.DEFAULT_PAGE;
              pageSize = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : _utils.DEFAULT_PAGE_SIZE;
              _context2.next = 4;
              return _this.fetchTags(page, pageSize);

            case 4:
              return _context2.abrupt("return", _context2.sent);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })), 500));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var item, storedPagination, _storedPagination$pag, pageSize, page, isPaginationSet;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!window.sessionStorage.getItem(_utils.PAGINATION_STORAGE_KEY)) {
                window.sessionStorage.setItem(_utils.PAGINATION_STORAGE_KEY, JSON.stringify(_utils.DEFAULT_PAGINATION));
              } else {
                item = window.sessionStorage.getItem(_utils.PAGINATION_STORAGE_KEY);
                storedPagination = item ? JSON.parse(item) : null;
                _storedPagination$pag = storedPagination.pagination, pageSize = _storedPagination$pag.pageSize, page = _storedPagination$pag.page;
                isPaginationSet = JSON.stringify(storedPagination) !== JSON.stringify(_utils.DEFAULT_PAGINATION);

                _this.setState(function (prevState) {
                  return {
                    pagination: _objectSpread(_objectSpread({}, prevState.pagination), {}, {
                      pageSize: pageSize,
                      page: page
                    }),
                    isPaginationSet: isPaginationSet
                  };
                });
              }

              _context3.next = 3;
              return _this.fetchTags(_this.state.pagination.page, _this.state.pagination.pageSize);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "editTag", /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(tagToEdit, newName) {
        var _this$state$paginatio, page, pageSize, _err$response, _err$response$data, errorMessage;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this.setState({
                  isLoading: true
                });

                if (newName) {
                  _context4.next = 4;
                  break;
                }

                _this.setState({
                  modalErrorMessage: 'Please enter tag name',
                  isLoading: false
                });

                return _context4.abrupt("return");

              case 4:
                if (!(tagToEdit.name === newName)) {
                  _context4.next = 7;
                  break;
                }

                _this.setState({
                  tagToEdit: undefined,
                  isLoading: false
                });

                return _context4.abrupt("return");

              case 7:
                _context4.prev = 7;
                _this$state$paginatio = _this.state.pagination, page = _this$state$paginatio.page, pageSize = _this$state$paginatio.pageSize;
                _context4.next = 11;
                return (0, _service.editTag)(tagToEdit.id, tagToEdit.name, newName, page, pageSize);

              case 11:
                _this.setState(function (prevState) {
                  return {
                    tags: prevState.tags.map(function (tag) {
                      if (tag.id !== tagToEdit.id) return tag;
                      return _objectSpread(_objectSpread({}, tag), {}, {
                        name: newName
                      });
                    }),
                    message: "Public tag '".concat(tagToEdit.name, "' has been renamed to '").concat(newName, "'!"),
                    messageType: 'success',
                    tagToEdit: undefined,
                    isLoading: false
                  };
                });

                _context4.next = 18;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](7);
                errorMessage = ((_err$response = _context4.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.errors) || _utils.DEFAULT_ERROR_MESSAGE;

                _this.setState({
                  modalErrorMessage: errorMessage,
                  isLoading: false,
                  messageType: null
                });

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[7, 14]]);
      }));

      return function (_x, _x2) {
        return _ref4.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "deleteTag", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(tagToDelete) {
        var successMessage, _this$state$paginatio2, page, pageSize, total, tags, currentPage, updatedTags, _yield$_this$index$ge, hits;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                successMessage = "Public tag '".concat(tagToDelete.name, "' has been deleted.");

                _this.setState({
                  tagToDelete: undefined,
                  isLoading: true,
                  messageType: null
                });

                _context5.prev = 2;
                _context5.next = 5;
                return (0, _service.deleteTag)(tagToDelete.id);

              case 5:
                _this$state$paginatio2 = _this.state.pagination, page = _this$state$paginatio2.page, pageSize = _this$state$paginatio2.pageSize, total = _this$state$paginatio2.total;
                tags = _this.state.tags;
                currentPage = page !== null && page !== void 0 ? page : _utils.DEFAULT_PAGE;

                if (!(tags.length === 1 && currentPage !== 1)) {
                  _context5.next = 13;
                  break;
                }

                _context5.next = 11;
                return _this.debouncedFetchTags(currentPage - 1, pageSize);

              case 11:
                _context5.next = 21;
                break;

              case 13:
                // eslint-disable-next-line eqeqeq
                updatedTags = tags.filter(function (tag) {
                  return tag.id != tagToDelete.id;
                });
                _context5.next = 16;
                return _this.index.getFirstRecordsFromNextPage(currentPage, pageSize);

              case 16:
                _yield$_this$index$ge = _context5.sent;
                hits = _yield$_this$index$ge.hits;

                if (hits.length === 1) {
                  updatedTags.push(hits[0]);
                }

                _this.index.clearCache();

                _this.setState({
                  tags: updatedTags,
                  pagination: {
                    page: currentPage,
                    pageSize: pageSize,
                    total: total ? total - 1 : total
                  }
                });

              case 21:
                _this.setState({
                  isLoading: false,
                  message: successMessage,
                  messageType: 'success'
                });

                _context5.next = 27;
                break;

              case 24:
                _context5.prev = 24;
                _context5.t0 = _context5["catch"](2);

                _this.setState({
                  message: _utils.DEFAULT_ERROR_MESSAGE,
                  messageType: 'error',
                  isLoading: false
                });

              case 27:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[2, 24]]);
      }));

      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPageChange", /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(page) {
        var pageSize;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                pageSize = _this.state.pagination.pageSize;

                _this.updatePagination(page, pageSize);

                _context6.next = 4;
                return _this.debouncedFetchTags(page, pageSize);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPageSizeChange", /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(pageSize) {
        var page;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                page = _utils.DEFAULT_PAGE;

                _this.updatePagination(page, pageSize);

                _context7.next = 4;
                return _this.debouncedFetchTags(page, pageSize);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x5) {
        return _ref7.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updatePagination", function (page, pageSize) {
      _this.setState(function (prevState) {
        return {
          pagination: _objectSpread(_objectSpread({}, prevState.pagination), {}, {
            pageSize: pageSize,
            page: page
          }),
          tagsToMerge: [],
          selectAllTagsOnPage: false
        };
      });

      (0, _utils.saveSessionPagination)(page, pageSize);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClickEditModalInput", function () {
      if (_this.state.modalErrorMessage) {
        _this.setState({
          modalErrorMessage: undefined
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectAllTags", function (value) {
      _this.setState(function (_ref8) {
        var tags = _ref8.tags;
        tags.forEach(function (t) {
          t.selected = value;
        });
        var selectedTags = value ? tags : [];
        return {
          selectAllTagsOnPage: value,
          tagsToMerge: selectedTags,
          tags: tags
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectTag", function (tag, value) {
      tag.selected = value;

      _this.setState(function (_ref9) {
        var tagsToMerge = _ref9.tagsToMerge;

        if (!value && tagsToMerge.includes(tag)) {
          var filteredTags = tagsToMerge.filter(function (t) {
            return t.id !== tag.id;
          });
          return {
            tagsToMerge: filteredTags
          };
        } else {
          tagsToMerge.push(tag);
          return {
            tagsToMerge: tagsToMerge
          };
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setAlertMessage", function (message, messageType) {
      _this.setState({
        message: message,
        messageType: messageType
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setTagsAndPagination", function (tags, pagination) {
      _this.setState({
        tags: tags,
        pagination: pagination,
        tagsToMerge: [],
        selectAllTagsOnPage: false,
        tagToEdit: undefined
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setIsLoading", function (isLoading) {
      _this.setState({
        isLoading: isLoading
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSearchInput", /*#__PURE__*/function () {
      var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(e) {
        var pagination, fetchTags;
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                pagination = _this.state.pagination;

                if (e.target instanceof HTMLInputElement) {
                  _context9.next = 3;
                  break;
                }

                return _context9.abrupt("return");

              case 3:
                fetchTags = /*#__PURE__*/function () {
                  var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
                    return _regenerator.default.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            _context8.next = 2;
                            return _this.debouncedFetchTags(pagination.page, pagination.pageSize);

                          case 2:
                            return _context8.abrupt("return", _context8.sent);

                          case 3:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee8);
                  }));

                  return function fetchTags() {
                    return _ref11.apply(this, arguments);
                  };
                }();

                _this.setState({
                  searchText: e.target.value
                }, fetchTags);

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function (_x6) {
        return _ref10.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onEditTag", /*#__PURE__*/function () {
      var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(tag) {
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this.setState({
                  tagToEdit: tag
                });

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function (_x7) {
        return _ref12.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRemoveTag", /*#__PURE__*/function () {
      var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(tag) {
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this.setState({
                  tagToDelete: tag,
                  messageType: null
                });

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      return function (_x8) {
        return _ref13.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeEditModal", function () {
      _this.setState({
        tagToEdit: undefined,
        modalErrorMessage: undefined
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeDeleteModal", function () {
      _this.setState({
        tagToDelete: undefined
      });
    });
    _this.index = new _TagsIndex.default();
    return _this;
  }

  (0, _createClass2.default)(PublicTagOverview, [{
    key: "render",
    value: function render() {
      return (0, _preact.h)(_PublicTagOverviewPresenter.default, (0, _extends2.default)({}, this.props, this.state, {
        tagIndex: this.index,
        onInput: this.onSearchInput,
        setAlertMessage: this.setAlertMessage,
        setIsLoading: this.setIsLoading,
        setTagsAndPagination: this.setTagsAndPagination,
        onSearchInput: this.onSearchInput,
        selectAllTags: this.selectAllTags,
        selectTag: this.selectTag,
        onEditTag: this.onEditTag,
        onRemoveTag: this.onRemoveTag,
        onPageChange: this.onPageChange,
        onPageSizeChange: this.onPageSizeChange,
        onClickEditModalInput: this.onClickEditModalInput,
        editTag: this.editTag,
        deleteTag: this.deleteTag,
        closeEditModal: this.closeEditModal,
        closeDeleteModal: this.closeDeleteModal
      }));
    }
  }]);
  return PublicTagOverview;
}(_preact.Component);

var _default = PublicTagOverview;
exports.default = _default;